/**
 * store/actions/types.js
 *
 * Constants for action types
 *
 */

export const SET_USER = 'SET_USER'
export const CLEAR_USER = 'CLEAR_USER'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const CLEAR_ACCOUNT = "CLEAR_ACCOUNT"
export const FETCH_ACCOUNT = 'FETCH_ACCOUNT'
export const RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT'
export const FETCH_ACCOUNT_ERROR = 'FETCH_ACCOUNT_ERROR'
export const INVALIDATE_ACCOUNT = "INVALIDATE_ACCOUNT"
export const SET_ACCOUNT_PAYMENT_METHOD = "SET_ACCOUNT_PAYMENT_METHOD"
export const SET_SERVICES = "SET_SERVICES"
export const SET_ENDPOINT = "SET_ENDPOINT"
export const CLEAR_ENDPOINT = "CLEAR_ENDPOINT"
